<template>
  <qx-card title="车辆列表">
    <LogRightDialog ref="logRightDialog" busiCode="100003" />
    <UploadDriverCardDialog
      ref="uploadDriverCardDialog"
      bizCodes="imp1000111"
      @sub="getData"
    />
    <UploadDriverCardDialog
      ref="uploadDriverCardPicDialog"
      bizCodes="imp1000111"
      :showVehicleClass="true"
      @sub="getData"
    />

    <section slot="titleRight">

      <qx-permpisions permpisions>
        <el-dropdown>
          <el-button type="primary" plain>
            <i class="iconfont">&#xe6ac;</i>批量操作
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <qx-permpisions>
              <el-dropdown-item @click.native="showUploadFileDialog"
                >上传文件新增车辆</el-dropdown-item
              >
            </qx-permpisions>
            <qx-permpisions>
              <el-dropdown-item @click.native="showUploadPicDialog"
                >上传图片新增车辆</el-dropdown-item
              >
            </qx-permpisions>
            <qx-permpisions>
              <el-dropdown-item @click.native="showBatchUploadLicenseDialog"
                >修改行驶证图片</el-dropdown-item
              >
            </qx-permpisions>
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>

      <qx-permpisions permpisions="1400216">
        <el-button
          type="primary"
          plain
          @click="() => showBatchUploadLicenseDialog()"
        >
          <i class="iconfont">&#xe6ad;</i>行驶证批量上传
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="1400209" style="margin-left: 0">
        <ImportBtn
          ref="importBtn"
          :noShow="true"
          title="车辆档案导入"
          bizCodes="imp1000120"
          downloadDesc="自有车、招商车、挂靠车档案请下载本模板"
          fileUrl="/file/车辆档案导入模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1400211">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleDataInfoBO.ajax?cmd=doQueryVehicleList"
          :params="fullSearchData"
          bizName="车辆档案信息导出"
          bizCode="exp100091"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1400201">
        <el-button type="primary" plain @click="() => toEdit({})">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'plateNumber'"
                  @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                    v-else-if="scope.column.property === 'remark'"
                    style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                >
                  <el-popover placement="top-start" width="120" trigger="hover">
                    <div >
                      <p>{{ scope.row[scope.column.property]}}</p>
                    </div>
                    <span class="cur" slot="reference">{{scope.row[scope.column.property]}}</span>
                  </el-popover>
<!--                  <span class="primary cur">-->
<!--                    {{ scope.row[scope.column.property] }}-->
<!--                  </span>-->
                </section>
                <section
                  v-else-if="scope.column.property === 'mobilePhone'"
                  @click="toDriverDetail(scope.row, '')"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-else-if="scope.column.property === 'tenantName'"
                  @click="toTenantDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-else-if="scope.column.property === 'cooperationCount'"
                  @click="toConveyDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>
                  <span>{{ scope.row[scope.column.property] }}</span>
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="130"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition: scope.row.isAuth === 1,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve', '审核车辆'),
                  },
                  {
                    permpisions: '1400202',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    permpisions: '1400214',
                    showCondition: scope.row.vehicleState === 1,
                    name: '闲置',
                    event: () => toIdle(scope.row, 0),
                  },
                  {
                    permpisions: '1400215',
                    showCondition: scope.row.vehicleState !== 1,
                    name: '启用',
                    event: () => toIdle(scope.row, 1),
                  },
                  {
                    permpisions: '1400203',
                    showCondition: true,
                    name: '删除',
                    event: () => del(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.relId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import UploadDriverCardDialog from 'components/uploadDriverCardDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  myCarSearchList,
  updateVehicleState,
  doRemoveVehicle,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ImportBtn,
    ExportBtn,
    UploadDriverCardDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'userId',
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号码', fixed: true },
          { prop: 'vehicleClassName', label: '车辆种类' },
          { prop: 'remark', label: '备注', w: 150 },
          { prop: 'linkman', label: '主驾姓名' },
          { prop: 'mobilePhone', label: '主驾手机' },
          { prop: 'licenceTypeName', label: '牌照类型' },
          { prop: 'energyTypeName', label: '能源类型', show: false },
          { prop: 'tenantName', label: '归属车队' },
          { prop: 'linkPhone', label: '车队手机' },
          { prop: 'cooperationCount', label: '合作车队' },
          // { prop: 'realTime', label: '实时位置时间' },
          // { prop: 'realTimeAddress', label: '实时位置' },
          { prop: 'locationServName', label: '定位类型' },
          { prop: 'beiDouSerivceDate', label: '定位生效时间' },
          { prop: 'vehicleInfo', label: '车辆类型' },
          { prop: 'authStateName', label: '待审核状态' },
          { prop: 'vehicleStateName', label: '使用状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: myCarSearchList,
    showUploadFileDialog () {
      this.$refs.importBtn.showImportDialog();
    },
    showBatchUploadLicenseDialog () { // 批量上传行驶证
      this.$refs.uploadDriverCardDialog.show();
    },
    showUploadPicDialog () {
      this.$refs.uploadDriverCardPicDialog.show();
    },
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet?id=${item.tenantId}`,
        full: true,
      });
    },
    toCarDetail (item) {
      const type = 'detail';
      this.jump({
        label: `查看车辆-${item.plateNumber}`,
        url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass}&type=${type}`,
        full: true,
      });
    },
    toDriverDetail (item, type) {
      this.jump({
        label: '查看司机档案',
        url: `/manage/archives/driver/archives/detail?id=${item.driverUserId}&type=${type}`,
        full: true,
      });
    },
    toConveyDetail (item) {
      this.jump({
        label: `合作车队详情-${item.plateNumber}`,
        url: `/manage/car/archives/my/cooperationMotorcade?id=${item.vehicleCode}`,
        full: true,
      });
    },
    toEdit (item) {

      /**
       * 下面这个页面除了【车辆管理-我的车辆】的新增和修改之外，还有一个入口是外调车辆的新增和修改，
       * 因为有一部分逻辑因为不同的入口进去处理逻辑不一样，所以添加一个 type 值来帮助区分判断，
       * 这里设置了 type = my 代表从【我的车辆】进去的，type = outward 代表从【外调车辆】进去的
       */
      const query = `id=${item.vehicleCode || ''}&vehicleClass=${item.vehicleClass || ''}&type=my&txjSwitch=${item.txjSwitch}`;
      let label = '';
      if (item.vehicleCode) {
        label = `修改我的车辆-${item.plateNumber}`;
      } else {
        label = '新增我的车辆';
      }
      this.jump({
        label,
        url: `/manage/car/archives/edit?${query}`,
        full: true,
      });
    },
    async toIdle (item, vehicleState) {
      const confirmRes = await this.$confirm(`确认${vehicleState ? '启用' : '停用'}车牌号【${item.plateNumber}】吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await updateVehicleState({
          vehicleCode: item.vehicleCode,
          vehicleState,
        });
        this.getData();
      }
    },
    toDetail (item, type = '', label = '') {
      this.jump({
        label,
        url: `/manage/car/archives/my/detail?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass}&relId=${item.relId}&type=${type}`,
        full: true,
      });
    },
    async del (item) {
      const confirmRes = await this.$confirm(`确认移除车牌号【${item.plateNumber}】的车辆？移除后您将无法使用该车辆，可在历史档案中查询车辆信息。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await doRemoveVehicle({ vehicleCode: item.vehicleCode });
        this.getData();
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>

<style>
</style>
